<template>
    <div>
        <!-- <Step1 v-if="step_no == 1" @onNext="onNextStep1"></Step1>
        <Step2 v-if="step_no == 2" @onNext="onNextStep2"></Step2> -->
        <Step1 v-if="step_no == 1" @onNext="onNextStepNew"></Step1>
        <el-dialog
          title="회원가입 완료"
          :visible.sync="dialogJoinComplete"
          width="30%">
          <!--<span>This is a message</span>-->
            <span>회원가입이 완료 되었습니다.</span>
          <span slot="footer" class="dialog-footer">
            <!--<el-button @click="dialogVisible = false">Cancel</el-button>-->
            <el-button type="primary" @click="join_complete">확인</el-button>
          </span>
        </el-dialog>
    </div>
    
</template>

<script>
    import Step1 from '../components/Join/Step1'
    import Step2 from '../components/Join/Step2'
    import { STATUS_CODE } from '@/lib/constants'
  export default {
    name: 'join',
    props: ['step_no'],
    data() {
      return {
        pharm: {
          email: null,
          pharm_name: '',
          pass: null,
          pass_re: null,
          pharmacy_pharm_name: null,
          contact: '',
          license_img: '',
          is_pharmacy: 0
        },
        dialogJoinComplete: false
        // upload_obj: null
      }
    },
    computed: {
    },
    methods: {
      onNextStep1(pharm) {
        this.pharm = Object.assign({}, this.pharm, pharm)
        this.$router.push('/join/2')
      },
      async onNextStep2(upload_obj) {

        let resp1 = await upload_obj.done()
        let [hash_key, filename] = resp1.uploaded_files[0]
        this.pharm.license_img = filename

        let { data: data2 } = await this.axios.post('pharmacist', this.pharm)
        let { resp: resp2 } = data2

        if (data2.status !== STATUS_CODE.OK){
          return alert(data2.msg);
        }else{
          // let pharm_id = data2.resp.pharm_id;
          // this.axios({ 
          //   method: 'post',
          //   url: '/doctor/notice/' + pharm_id,
          // }).then((response) => {
          //     if(!response.data.has_error){ //성공
            
          //     }else{ //실패

          //     }
          // }).catch((error) => {
          //     console.log('error!: ', error);
          // }).finally(() => {
              
          // });
        }

        this.dialogJoinComplete = true

        // this.step = 3 // 성공을 해야 바꿔준다.
        // this.upload_obj = upload_obj
      },
      async onNextStepNew(pharm) {
        this.pharm = Object.assign({}, this.pharm, pharm)
        let { data: data2 } = await this.axios.post('pharmacist', this.pharm)
        let { resp: resp2 } = data2
        if (data2.status !== STATUS_CODE.OK){
          return alert(data2.msg);
        }else{
          let pharm_id = data2.resp.pharm_id;
          
          // 회원 가입 완료 시 관리자에게 이메일 및 알림톡 전송
          this.axios({ 
            method: 'post',
            url: '/pharmacist/notice/' + pharm_id,
          }).then((response) => {
              if(!response.data.has_error){ //성공
            
              }else{ //실패

              }
          }).catch((error) => {
              console.log('error!: ', error);
          }).finally(() => {
              
          });
        }
        this.dialogJoinComplete = true
      },
      join_complete() {
        this.dialogJoinComplete = false
        this.$router.push('/')
      }
    },
    components: {
      Step1, Step2
    }
  }
</script>

<style scoped>

</style>